import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { YMInitializer } from 'react-yandex-metrika';

import './static/css/index.css';
import App from './App';

const root = document.getElementById("root");
const app = <>
  <YMInitializer accounts={[85711564,]} options={ {webvisor: true, clickmap:true, trackLinks:true, accurateTrackBounce:true,} } version="2" />
  <BrowserRouter>
    <App />
  </BrowserRouter>
</>;

if (root.hasChildNodes()) {
  ReactDOM.hydrate(app, root);
} else {
  ReactDOM.render(app, root);
}
